// export const IMG_PATH = 'http://localhost:8000/static/';
// export const IMG_PATH = 'http://128.199.231.41:8000/static/';
export const IMG_PATH= 'https://api.mobileconnectsolution.com/static/';